import { useMemo } from "react";
import { useParams } from "react-router-dom";

export function useSubmissionIdFromParams(): string {
  const params = useParams();

  return useMemo(() => {
    const idParam = params.id?.trim();
    if (idParam) {
      return idParam;
    }

    const explicit = params.submission_id?.trim();
    if (explicit) {
      return explicit;
    }

    const splat = params["*"]?.trim();
    if (!splat) {
      return "";
    }

    return splat.split("/")[0] ?? "";
  }, [params]);
}
